import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [
      "common",
      "dashboard",
      "forms",
      "genres",
      "auth",
      "sidebar",
      "timezones",
      "classroom",
      "calendar",
      "help",
      "finances",
      "terms_of_service",
      "privacy_policy",
    ],
    supportedLngs: ["GB", "pl", "es", "US", "en"],
    fallbackLng: {
      US: ["en"],
      GB: ["en"],
      default: ["en"],
    },
    detection: {
      order: ["localStorage", "htmlTag", "navigator", "path"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

z.setErrorMap(zodI18nMap);

export default i18n;
